const DotInactive = (props: any) => (
    <svg
        width={12}
        height={13}
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6 4.32324C6.48984 4.32321 6.96889 4.46709 7.37766 4.73699C7.78643 5.0069 8.10691 5.39094 8.29928 5.84142C8.49165 6.2919 8.54745 6.78898 8.45974 7.2709C8.37203 7.75282 8.14467 8.19836 7.80591 8.55217C7.46716 8.90598 7.03192 9.15249 6.55427 9.26106C6.07661 9.36963 5.57758 9.33549 5.11917 9.16287C4.66075 8.99026 4.26314 8.68678 3.97573 8.29012C3.68831 7.89347 3.52376 7.42112 3.5025 6.93174L3.5 6.82324L3.5025 6.71474C3.53046 6.07112 3.8058 5.46313 4.27111 5.01757C4.73642 4.57201 5.35577 4.32328 6 4.32324Z"
            fill="#98A2B3"
        />
    </svg>
);

export default DotInactive;
